module.exports = __webpack_public_path__ + "img/number-two.2839d919.png";